(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-newsletter-popup"]) return;
  try {
    
(() => {
  const setup = () => {
    const dialog = document.getElementById('pp-newsletter');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const key = 'pp_newsletter_dismissed_until';
    const subscribedKey = 'pp_newsletter_subscribed';
    const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
    const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
    const close = () => { write(key, String(Date.now() + 7 * 86400000)); dialog.close(); };
    dialog.querySelector('.pp-close').addEventListener('click', close);
    dialog.querySelector('.pp-dismiss').addEventListener('click', close);
    dialog.addEventListener('cancel', () => write(key, String(Date.now() + 7 * 86400000)));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
    const success = dialog.querySelector('[data-pp-success]');
    const errors = dialog.querySelector('[data-pp-error]');
    if (success) write(subscribedKey, 'true');
    if (success || errors) { dialog.showModal(); return; }
    if (read(subscribedKey) || Number(read(key)) > Date.now()) return;
    window.setTimeout(() => {
      if (dialog.isConnected && !document.querySelector('dialog[open]')) dialog.showModal();
    }, 4000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();
})();
